import script from "./MobileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileView.vue?vue&type=script&setup=true&lang=ts"

import "./MobileView.vue?vue&type=style&index=0&id=757a1a14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757a1a14"]])

export default __exports__